module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_4"
    }
  }, [_c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "id": "Page_vii",
      "title": "[Pg vii]"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre12",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre13"
  }, [_c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("PATIENCE ON A GATE,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#CHAPTER_I"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("IN THE VERANDAH,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#CHAPTER_II"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("AN EARLY VISIT,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#CHAPTER_III"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("ANGEL IN EXCELSIS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#CHAPTER_IV"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v(" THE LUCKNOW ROAD,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#CHAPTER_V"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("LATE FOR MESS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008#CHAPTER_VI"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("MRS. DAWSON'S DRESSES,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0009#CHAPTER_VII"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE PICNIC,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#CHAPTER_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE BEQUEST,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#CHAPTER_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("X.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A CHALLENGE,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#CHAPTER_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("WHO IS SHE?")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#CHAPTER_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("ANGEL IMPARTS A SECRET,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#CHAPTER_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("ANGEL'S WINGS ARE CLIPPED,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#CHAPTER_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("PHILIP'S LOVE AFFAIR,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#CHAPTER_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("LOLA,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#CHAPTER_XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("GRANDMAMMA,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#CHAPTER_XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE UNEXPECTED,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#CHAPTER_XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("DINNER FOR TWO,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#CHAPTER_XVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE PARTING GUESTS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#CHAPTER_XIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A DESTROYING ANGEL,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#CHAPTER_XX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("\"THINK IT OVER,\"")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#CHAPTER_XXI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")]), _c('span', {
    attrs: {
      "id": "pgepubid00002",
      "title": "[Pg viii]"
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("\"A WHITE ELEPHANT AND A WHITE ROSE,\"")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#CHAPTER_XXII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("ANGEL DECLINES A PENNY FOR HER THOUGHTS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#CHAPTER_XXIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE SOOTHSAYER,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026#CHAPTER_XXIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE CHITACHAR CLUB,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027#CHAPTER_XXV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("IN ANGEL'S TENT,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0028#CHAPTER_XXVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("\"THE SIN,\"")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0029#CHAPTER_XXVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("MAKING FRIENDS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0030#CHAPTER_XXVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("LAST YEAR'S NEST,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0031#CHAPTER_XXIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A WHITED SEPULCHRE,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0032#CHAPTER_XXX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("291")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("FISHING FOR AN INVITATION,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0033#CHAPTER_XXXI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("296")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("BY PROXY,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0034#CHAPTER_XXXII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("EXPLANATION,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0035#CHAPTER_XXXIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("313")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXIV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A REFUGEE,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0036#CHAPTER_XXXIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("320")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXV.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A GOOD BILLET,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0037#CHAPTER_XXXV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("330")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXVI.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("JOINT HOSTESS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0038#CHAPTER_XXXVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXVII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("IN GARHWAL,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0039#CHAPTER_XXXVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXVIII.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("INTERLOPERS,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0040#CHAPTER_XXXVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXIX.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("TO DIE WITH YOU,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0041#CHAPTER_XXXIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XL.  ")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE INTRUDER,")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0042#CHAPTER_XL",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("375")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0